import { SAUXTheme } from '@saux/design-system-react';
import styled from 'styled-components';
import customBase from '../../util/global.theme';
import useIsResponsive from '../../util/useIsResponsive';

export const LastDayToPayText = styled.div`
  ${({ theme }: { theme: SAUXTheme }) => `
  small {
    color: #7A5212;
  }
  height: 40px;
  margin: ${theme.size.spacer.small} -150px ${theme.size.spacer.medium} 0px;
  @media screen and (max-width: ${customBase.global.breakpoints.medium}px) {
    margin: ${theme.size.spacer.medium} 0px ${theme.size.spacer.large} 0px;
  }
  `}
`;

export const LastDayToPaySpacer = styled.div`
  height: 30px;
`;

export const NextPaymentWrapper = styled.div`
  ${({ theme }: { theme: SAUXTheme }) => `
    display: flex;
    flex-direction: column;
    padding-left: ${theme.size.spacer.medium};
    min-height: 161px;
    
    @media screen and (min-width: ${customBase.global.breakpoints.medium}px) {
      padding-left: 0px;
      min-width: 360px;
      justify-content: space-between;
      flex-direction: row;
      min-height: 161px;
    }
  `}
`;

export const NextPaymentWrapperError = styled.div`
  ${({ theme }: { theme: SAUXTheme }) => {
    return `
    display: flex;
    flex-direction: column;
    min-width: 300px;
    min-height: 161px;

    @media screen and (max-width: ${customBase.global.breakpoints.medium}px) {
      flex-direction: row;
      justify-content: space-between;
      padding-left: ${theme.size.spacer.large};
    }
  `;
  }}
`;

export const AmountDueWrapper = styled.div`
  ${({ theme }: { theme: SAUXTheme }) => `
    min-width: 132px;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    margin-bottom: ${theme.size.spacer.small};
  `}
`;

export const AmountDue = styled.p`
  ${({ theme }: { theme: SAUXTheme }) => `
    font-size: 40px;
    font-weight: ${theme.font.primary.weight.bold};
    color: ${theme.colors.accentBlue900};
  `}
`;

export const DueDate = styled.p`
  ${({ theme }: { theme: SAUXTheme }) => `
    font-size: ${theme.font.primary.size.mediumTEMP};
  `}
`;

export const MakePaymentButtonWrapper = styled.div`
  ${({ theme }: { theme: SAUXTheme }) => `
    display: flex;
    justify-content: left;

    @media screen and (max-width: ${customBase.global.breakpoints.small}px) {
      width: auto;
      margin-right: ${theme.size.spacer.small};
    }
`}
`;

export const Border = styled.div`
  border-bottom: 1px solid transparent;
`;

export const MakePaymentButtonSpacer = styled.div`
  margin-bottom: 19px;
`;

export const ResponsiveButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

export const DesktopButtonWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  width: 100%;
`;

export const PastDueCard = styled.div`
  ${({ theme, showLastDay }: { theme: SAUXTheme; showLastDay: boolean }) => {
    const isResponsive = useIsResponsive();
    return `
    display: flex;
    flex-direction: column;
    max-height: 100px;
    width: auto;
    padding: ${theme.size.spacer.medium};
    margin: ${
      showLastDay && !isResponsive
        ? `0px ${theme.size.spacer.small} 0px 0px`
        : `${theme.size.spacer.medium} ${theme.size.spacer.small} 0px 0px`
    };
    @media screen and (min-width: ${customBase.global.breakpoints.medium}px) {
      width: 160px;
      height: 105px;
      padding: ${theme.size.spacer.medium};
      padding-top: 0px;
    }
  `;
  }}
`;

export const PastDueAmountWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PastDueHeader = styled.p`
  ${({ theme }: { theme: SAUXTheme }) => `
    color: #041E41;
    font-size: ${theme.font.primary.size.smallTEMP};
    font-weight: ${theme.font.primary.weight.bold};
  `}
`;

export const PastDueIndicator = styled.div`
  display: flex;
  margin-bottom: 15px;
  @media screen and (min-width: ${customBase.global.breakpoints.medium}px) {
    margin-bottom: 0px;
  }
`;

export const ResponsiveToolTipIconWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 10px;
  padding-right: 4px;
`;

export const DesktopScheduleTextHolder = styled.div`
  display: none;
  @media screen and (min-width: ${customBase.global.breakpoints.medium}px) {
    display: block;
  }
`;

export const MobileScheduleTextHolder = styled.div`
  display: block;
  @media screen and (min-width: ${customBase.global.breakpoints.medium}px) {
    display: none;
  }
`;

export const AmountAndButtonWrapper = styled.div``;

export const DesktopToolTipWrapper = styled.div`
  &:hover {
    cursor: help;
  }
`;

export const FullSizeToolTip = styled.div`
  margin-top: 6px;
`;

export const InfoIconWhiteOutHolder = styled.div`
  padding: 7px 12px 0px 0px;
`;

export const ToolTipHolder = styled.div`
  ${({ theme }: { theme: SAUXTheme }) => `
  position: absolute;
  margin-top: -41px;
  margin-left: 24px;
  width: 275px;
  height: 56px;
  display: flex;
  flex-direction: row;
  background-color: #3e5572;
  border-radius: ${theme.size.radius.small};
  color: #fff;
  padding: 11px 12px 13px 12px;
`}
`;

export const MortgageePaymentWordingText = styled.div`
  margin: 6px 12px 0px 0px;
  @media screen and (min-width: ${customBase.global.breakpoints.small}px) {
    margin: 0px 12px 0px 0px;
  }
`;

export const LastPaymentWrapper = styled.div`
  ${({ theme }: { theme: SAUXTheme }) => `
    max-heigh: 100px;
    min-width: 175px;
    border: 1px solid ${theme.colors.blueGray300};
    border-radius: 4px;
    padding: 10px;
  `}
`;

export const ReceivedOnWrapper = styled.div`
  display: flex;
  direction: row;
  gap: 5px;
  align-items: center;
`;
